import React from 'react'
import pic from '../Images/project1.PNG';
import pic2 from '../Images/pro2.PNG';
import pic1 from '../Images/pr1.PNG';
import 'aos/dist/aos.css'

export default function project() {
  return (
     <>
     <p className='flex justify-center pt-10 sm:pt-40 text-4xl sm:text-6xl text-slate-300 font-cust'>My Projects</p>
     
     <div className='lg:grid lg:grid-cols-2'>

        <div data-aos="flip-down" className='w-full h-auto'> 
            <img className= 'sm:ml-10 flex sm:mt-40 mt-10 shadow-2xl shadow-black hover:shadow-rose-500 sm:h-60 lg:h-80 h-40 
            w-auto rounded-2xl sm:-skew-y-3 lg:blur-sm hover:blur-none' src={pic1} alt=''/>
        </div>

        <div className='text-white lg:pt-40 pt-10 sm:ml-20 md:ml-40 lg:ml-20 ml-3'>
           <h2 className='text-rose-600 text-2xl sm:text-4xl font-bold'>Netflix UI Clone</h2>
           <p className='text-xl sm:text-2xl lg:pt-5 pt-5 text-rose-200 w-60 sm:w-96'>
              A Netflix clone made using React JS, Javascript, CSS and HTML5 with features like Scrolling, Genres, and Posters.
           </p>
           <div className='sm:pt-10 pt-5'>
           <button data-aos="fade-left" className= 'hover:text-rose-500 bg-transparent text-white border-2 border-rose-500 hover:border-transparent rounded-xl hover:text-xl sm:hover:text-4xl sm:w-40 w-20 sm:h-10 h-8'>
             <a href='https://netflix-alpha-six.vercel.app/' rel="noreferrer" target="_blank">See Live</a></button>
           </div>
        </div>

     </div>
     
     <div className='lg:grid lg:grid-cols-2'>
          <div className='text-white sm:pt-60 pt-10 sm:ml-10 md:ml-20 ml-3'>
            <h2 className='text-orange-400 text-2xl sm:text-4xl font-bold'>Tempria: A Weather App</h2>
            <p className='text-xl sm:text-2xl sm:pt-10 pt-5 text-sky-200 w-60 sm:w-96'>
               This is a weather App made using Reactjs and Tailwindcss. I got to learn about how to use weather APIs.
            </p>
            <div  className='sm:pt-10 pt-5'>
            <button data-aos="fade-right"  className= 'hover:text-orange-400 bg-transparent text-white border-2 hover:border-transparent border-orange-400 rounded-xl hover:text-xl sm:hover:text-4xl sm:w-40 w-20 sm:h-10 h-8'>
               <a href='https://singhanurrag.github.io/Tempria/' rel="noreferrer" target="_blank">See Live</a></button>
            </div>
        </div>

        <div data-aos="flip-up" className='w-full h-auto'> 
            <img className= 'flex lg:-ml-10 sm:ml-10 lg:mt-60 mt-10 shadow-2xl shadow-slate-500 hover:shadow-sky-500 sm:h-60 lg:h-80 h-40 w-auto rounded-2xl sm:skew-y-3 lg:blur-sm hover:blur-none' src={pic} alt=' '/>
        </div>
     </div>

     <div className='lg:grid lg:grid-cols-2'>

        <div data-aos="flip-down" className='w-full h-auto'> 
            <img className= 'sm:ml-10 flex sm:mt-60 mt-10 shadow-2xl shadow-black hover:shadow-blue-600 sm:h-60 lg:h-80 h-40 w-auto rounded-2xl sm:-skew-y-3 lg:blur-sm hover:blur-none' src={pic2} alt=' '/>
        </div>

        <div className='text-white lg:pt-60 pt-10 sm:ml-20 md:ml-40 lg:ml-20 ml-3'>
           <h2 className='text-gray-200 text-2xl sm:text-4xl font-bold'>TextUtils</h2>
           <p className='text-xl sm:text-2xl lg:pt-5 pt-5 text-gray-400 w-60 sm:w-96'>
              A text manipulating app built with Reactjs and Bootstrap. I learned how to change background color modes through this one.
           </p>
           <div className='sm:pt-10 pt-5'>
           <button data-aos="fade-left" className= 'hover:text-gray-200 bg-transparent text-white border-2 border-blue-600 hover:border-transparent rounded-xl hover:text-xl sm:hover:text-4xl sm:w-40 w-20 sm:h-10 h-8'>
             <a href='http://singhanurrag.github.io/TextUtils-React' rel="noreferrer" target="_blank">See Live</a></button>
           </div>
        </div>

     </div>
    </>
  )
}
